module.exports = __webpack_public_path__ + "img/alf_sweden.dfed1c60.png";